import { ErrorMessageSchema } from "@common/schemas/error.schema";
import {
    createWorkspaceEmailAliasSchema,
    listWorkspaceEmailAliasesResponseSchema,
    workspaceEmailAliasKindSchema,
    workspaceEmailAliasSchema,
} from "@common/schemas/workspace-email-alias.schema";
import { initContract } from "@ts-rest/core";
import { z } from "zod";

const c = initContract();

export const workspaceEmailAliasContract = c.router(
    {
        getForWorkspace: {
            method: "GET",
            path: "/:workspaceId",
            responses: {
                200: listWorkspaceEmailAliasesResponseSchema,
            },
        },
        create: {
            method: "POST",
            path: "/:workspaceId",
            body: createWorkspaceEmailAliasSchema,
            responses: {
                201: workspaceEmailAliasSchema,
                400: ErrorMessageSchema,
                404: ErrorMessageSchema,
                409: ErrorMessageSchema,
            },
        },
        remove: {
            method: "DELETE",
            path: "/:workspaceId/:emailLocalPart",
            query: z.object({ kind: workspaceEmailAliasKindSchema }),
            body: c.noBody(),
            responses: {
                204: c.noBody(),
            },
        },
    },
    {
        pathPrefix: "/workspace-email-aliases",
    },
);
